import { render, staticRenderFns } from "./TelephoneNumber.vue?vue&type=template&id=0fe0f3dd&"
import script from "./TelephoneNumber.vue?vue&type=script&lang=ts&"
export * from "./TelephoneNumber.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports